import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';

export const StylesGhostSaleBadge = styled.div`
  position: absolute;
  z-index: 15;
  top: -7px;
  right: -7px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;

  .ghost-sale-badge {
    &--container {
      position: relative;
      width: 48px;
      height: 48px;

      .ghost-sale-badge {
        &--image {
          width: 100%;
          height: 100%;
          max-height: 48px;
          object-fit: contain;
        }

        &--number {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          color: #fff;
          font-size: 12px;
          font-weight: 950;
          text-align: center;
          font-style: normal;

          &-text {
            text-transform: uppercase;
          }
        }
      }
    }
  }
`;
